import React from 'react';
import {
  Container,
  Content,
  Footer,
  ContainerModal,
  Text,
} from './styles/StyledModalSketchReporting';
import { Icon, Typography, Button } from '@wisecare-tech/design-system-web';
import { iMessage } from '~/domain/interfaces/models';
import { MessageOptions } from '~/domain/interfaces/redux/message';

interface ownProps {
  message: iMessage;
}

const ModalSketchReporting: React.FC<ownProps> = ({ message }) => {
  const { active, actionCancel, actionOk, data } = message;

  const msgName = MessageOptions.sketchReporting;

  return (
    <>
      {msgName === active && (
        <ContainerModal>
          <Container>
            <Content>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#E6F0FB',
                  borderRadius: '9999px',
                  aspectRatio: '1',
                  width: '40px',
                }}
              >
                <Icon name="info" color="blue-7" size="h5" />
              </div>
              <Text>
                <Typography
                  variant="t1_18semibold"
                  style={{ fontFamily: 'Roboto' }}
                >
                  Salvar laudo como um esboço
                </Typography>
                <Typography
                  variant="b1_16regular"
                  style={{
                    color: '#656A6E',
                    fontFamily: 'Roboto',
                    fontSize: '16px',
                  }}
                >
                  Você está salvando o que escreveu até agora como um esboço,
                  essa solicitação ficará agora apresentada como designada para
                  você. Na tabela, estará salvo na aba de “Laudando”.
                </Typography>
              </Text>
            </Content>
            <Footer>
              <Button variant="secondary" onClick={actionCancel}>
                Voltar para o laudo
              </Button>
              <Button variant="primary" onClick={actionOk}>
                Salvar como esboço
              </Button>
            </Footer>
          </Container>
        </ContainerModal>
      )}
    </>
  );
};

export default ModalSketchReporting;
